import axios from 'axios'


// export async function getHttpRequest(url) {
//     return await axios.get(url, {
//         headers: {
//             Authentication: "Bearer " + getStoreValue("tokenauth"),
//         },
//     }).then(response => {
//         return response.data
//     }).catch(error => {
//         return error
//     })
// }

export async function getHttpRequestNoAuth(url) {
    return await axios.get(url).then(response => {
        return response.data;
    }).catch(error => {
        console.error("getHttpRequestNoAuth error", error);
        throw error;
    })
}

// export async function postHttpFormDataRequest(url, formData) {
//     return await axios({
//         method: "post",
//         headers: {
//             Authentication: "Bearer " + getStoreValue("tokenauth"),
//         },
//         url: url,
//         data: formData,
//         config: { headers: { "Content-Type": "multipart/form-data" } }
//     }).then(response => {
//         return response.data
//     }).catch(error => {
//         return error
//     })
// }

export async function putHttpRequestNoAuth(url, jsonObject) {
    return await axios({
        method: "put",
        headers: {},
        url: url,
        data: jsonObject,
        
    }).then(response => {
        return response.data
    }).catch(error => {
        console.error("putHttpRequestNoAuth error", error);
        throw error;
    })
}